import { getToken, returnError } from './helperFunc';
import {
  machineStatusAction,
  channelSalesAction,
  machineSalesAction,
  weeklySalesAction,
  totalOutletSalesByYearAction,
  annualSalesReportAction,
  todaySalesAction,
  outOfServiceMachineStatusAction,
  offlineMachineStatusAction,
  unconfiguredMachineStatusAction,
  billAcceptorSalesAction,
  mtdSalesAction,
  todayMachineSalesAction,
  mtdMachineSalesAction,
  monthlyOutletSalesAction,
  dailyOutletSalesAction,
  monthlysingleOutletSalesAction,
  dailySingleOutletSalesAction,
  billAcceptorTodaySalesAction,
  billAcceptorMTDSalesAction,
  billAcceptorMonthlyOutletSalesAction,
  billAcceptorDailyOutletSalesAction,
  billAcceptorMonthlySingleSalesAction,
  billAcceptorDailySingleSalesAction,
  billAcceptorTodaySingleSalesAction,
  billAcceptorMTDSingleSalesAction,
  machineBillStatusAction,
  totalDailySalesBy30daysAction,
} from './requestEndpoints';

import { LOGOUT_SUCCESS } from './userReducer';

const SET_SUM_LOADING = 'SET_SUM_LOADING';
const CLEAR_SUM_ERROR = 'CLEAR_SUM_ERROR';
const CLEAR_SUM_ERRORv2 = 'CLEAR_SUM_ERRORv2';
const SET_SUM_LOADINGv2 = 'SET_SUM_LOADINGv2'

const MACHINE_STATUS_SUCCESS = 'MACHINE_STATUS_SUCCESS';
const MACHINE_STATUS_FAIL = 'MACHINE_STATUS_FAIL';
const OUT_OF_SERVICE_MACHINE_STATUS = 'OUT_OF_SERVICE_MACHINE_STATUS';
const OUT_OF_SERVICE_MACHINE_FAIL = 'OUT_OF_SERVICE_MACHINE_FAIL';
const CHANNEL_SALES_SUCCESS = 'CHANNEL_SALES_SUCCESS';
const CHANNEL_SALES_FAIL = 'CHANNEL_SALES_FAIL';
const MACHINE_SALES_SUCCESS = 'MACHINE_SALES_SUCCESS';
const MACHINE_SALES_FAIL = 'MACHINE_SALES_FAIL';
const ANNUAL_SALES_SUCCESS = 'ANNUAL_SALES_SUCCESS';
const ANNUAL_SALES_FAIL = 'ANNUAL_SALES_FAIL';
const LASTWEEK_SALES_SUCCESS = 'LASTWEEK_SALES_SUCCESS';
const LASTWEEK_SALES_FAIL = 'LASTWEEK_SALES_FAIL';
const OUTLET_SALES_SUCCESS = 'OUTLET_SALES_SUCCESS';
const OUTLET_SALES_FAIL = 'OUTLET_SALES_FAIL';
const CLEAR_FILTER_SUCCESS = 'CLEAR_FILTER_SUCCESS';
const TOP_SALES_SUCCESS = 'TOP_SALES_SUCCESS';
const TOP_SALES_FAIL = 'TOP_SALES_FAIL';

const TODAY_SALES_SUCCESS = 'TODAY_SALES_SUCCESS';
const TODAY_SALES_FAIL = 'TODAY_SALES_FAIL';

const WEEKLY_SALES_SUCCESS = 'WEEKLY_SALES_SUCCESS';
const WEEKLY_SALES_FAIL = 'WEEKLY_SALES_FAIL';

const OFFLINE_MACHINE_STATUS = 'OFFLINE_MACHINE_STATUS';
const OFFLINE_MACHINE_FAIL = 'OFFLINE_MACHINE_FAIL';

const UNCONFIGURED_MACHINE_STATUS = 'UNCONFIGURED_MACHINE_STATUS';
const UNCONFIGURED_MACHINE_FAIL = 'UNCONFIGURED_MACHINE_FAIL';

const BILL_ACCEPTOR_SALES_SUCCESS = 'BILL_ACCEPTOR_SALES_SUCCESS';
const BILL_ACCEPTOR_SALES_FAIL = 'BILL_ACCEPTOR_SALES_FAIL';

const OUTLETS_MONTH_SUCCESSV2 = 'OUTLETS_MONTH_SUCCESSV2';
const OUTLETS_MONTH_FAILV2 = 'OUTLETS_MONTH_FAILV2';

const TOP_SALES_SUCCESSV2 = 'TOP_SALES_SUCCESSV2'
const TOP_SALES_FAILV2 = 'TOP_SALES_FAILV2'

const MTD_SALES_SUCCESS = 'MTD_SALES_SUCCESS';
const MTD_SALES_FAIL = 'MTD_SALES_FAIL';

const TODAY_MACHINE_SALES_SUCCESS = 'TODAY_MACHINE_SALES_SUCCESS';
const TODAY_MACHINE_SALES_FAIL = 'TODAY_MACHINE_SALES_FAIL';

const MTD_MACHINE_SALES_SUCCESS = 'MTD_MACHINE_SALES_SUCCESS';
const MTD_MACHINE_SALES_FAIL = 'MTD_MACHINE_SALES_FAIL';

const MONTHLY_OUTLET_SUCCESS = 'MONTHLY_OUTLET_SUCCESS';
const MONTHLY_OUTLET_FAILED = 'MONTHLY_OUTLET_FAILED';

const DAILY_OUTLET_SUCCESS = 'DAILY_OUTLET_SUCCESS';
const DAILY_OUTLET_FAILED = 'DAILY_OUTLET_FAILED';

const MONTHLY_SINGLE_OUTLET_SUCCESS = 'MONTHLY_SINGLE_OUTLET_SUCCESS';
const MONTHLY_SINGLE_OUTLET_FAILED = 'MONTHLY_SINGLE_OUTLET_FAILED';

const DAILY_SINGLE_OUTLET_SUCCESS = 'DAILY_SINGLE_OUTLET_SUCCESS';
const DAILY_SINGLE_OUTLET_FAILED = 'DAILY_SINGLE_OUTLET_FAILED';

const BILL_ACCEPTOR_TODAY_SUCCESS = 'BILL_ACCEPTOR_TODAY_SUCCESS';
const BILL_ACCEPTOR_TODAY_FAIL = 'BILL_ACCEPTOR_TODAY_FAIL';

const BILL_ACCEPTOR_MTD_SUCCESS = 'BILL_ACCEPTOR_MTD_SUCCESS';
const BILL_ACCEPTOR_MTD_FAIL = 'BILL_ACCEPTOR_MTD_FAIL';

const BILL_ACCEPTOR_MONTHLY_OUTLET_SUCCESS = 'BILL_ACCEPTOR_MONTHLY_OUTLET_SUCCESS';
const BILL_ACCEPTOR_MONTHLY_OUTLET_FAIL = 'BILL_ACCEPTOR_MONTHLY_OUTLET_FAIL';

const BILL_ACCEPTOR_DAILY_OUTLET_SUCCESS = 'BILL_ACCEPTOR_DAILY_OUTLET_SUCCESS';
const BILL_ACCEPTOR_DAILY_OUTLET_FAIL = 'BILL_ACCEPTOR_DAILY_OUTLET_FAIL';

const BILL_ACCEPTOR_MONTHLY_SINGLE_SUCCESS = 'BILL_ACCEPTOR_MONTHLY_SINGLE_SUCCESS';
const BILL_ACCEPTOR_MONTHLY_SINGLE_FAIL = 'BILL_ACCEPTOR_MONTHLY_SINGLE_FAIL';

const BILL_ACCEPTOR_DAILY_SINGLE_SUCCESS = 'BILL_ACCEPTOR_DAILY_SINGLE_SUCCESS';
const BILL_ACCEPTOR_DAILY_SINGLE_FAIL = 'BILL_ACCEPTOR_DAILY_SINGLE_FAIL';

const BILL_ACCEPTOR_TODAY_SINGLE_SUCCESS = 'BILL_ACCEPTOR_TODAY_SINGLE_SUCCESS';
const BILL_ACCEPTOR_TODAY_SINGLE_FAIL = 'BILL_ACCEPTOR_TODAY_SINGLE_FAIL';

const BILL_ACCEPTOR_MTD_SINGLE_SUCCESS = 'BILL_ACCEPTOR_MTD_SINGLE_SUCCESS';
const BILL_ACCEPTOR_MTD_SINGLE_FAIL = 'BILL_ACCEPTOR_MTD_SINGLE_FAIL';

const MACHINE_BILL_STATUS_SUCCESS = 'MACHINE_BILL_STATUS_SUCCESS';
const MACHINE_BILL_STATUS_FAIL = 'MACHINE_BILL_STATUS_FAIL';

const LAST30DAYS_SALES_SUCCESS = 'LAST30DAYS_SALES_SUCCESS';
const LAST30DAYS_SALES_FAIL = 'LAST30DAYS_SALES_FAIL';

export const machineStatus =
  (year, operatorId) => async (dispatch, getState) => {
    try {
      dispatch({ type: CLEAR_SUM_ERROR });
      dispatch({ type: SET_SUM_LOADING });

      const { user } = getState();

      const token = getToken(user);

      const { data } = await machineStatusAction(year, operatorId, token);

      dispatch({ type: MACHINE_STATUS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: MACHINE_STATUS_FAIL, payload: returnError(error) });
    }
  };

export const machineBillStatus =
  (year, operatorId) => async (dispatch, getState) => {
    try {
      dispatch({ type: CLEAR_SUM_ERROR });
      dispatch({ type: SET_SUM_LOADING });

      const { user } = getState();

      const token = getToken(user);

      const { data } = await machineBillStatusAction(year, operatorId, token);

      dispatch({ type: MACHINE_BILL_STATUS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: MACHINE_BILL_STATUS_FAIL, payload: returnError(error) });
    }
  };

export const outOfServiceMachineStatus =
  (year, operatorId) => async (dispatch, getState) => {
    try {
      dispatch({ type: CLEAR_SUM_ERRORv2 });
      dispatch({ type: SET_SUM_LOADINGv2 });

      const { user } = getState();

      const token = getToken(user);

      const { data } = await outOfServiceMachineStatusAction(year, operatorId, token);

      dispatch({ type: OUT_OF_SERVICE_MACHINE_STATUS, payload: data });
    } catch (error) {
      dispatch({ type: OUT_OF_SERVICE_MACHINE_FAIL, payload: returnError(error) });
    }
  };

export const offlineMachineStatus =
  (year, operatorId) => async (dispatch, getState) => {
    try {
      dispatch({ type: CLEAR_SUM_ERROR });
      dispatch({ type: SET_SUM_LOADING });

      const { user } = getState();

      const token = getToken(user);

      const { data } = await offlineMachineStatusAction(year, operatorId, token);

      dispatch({ type: OFFLINE_MACHINE_STATUS, payload: data });
    } catch (error) {
      dispatch({ type: OFFLINE_MACHINE_FAIL, payload: returnError(error) });
    }
  };

export const unconfiguredMachineStatus =
  (year, operatorId) => async (dispatch, getState) => {
    try {
      dispatch({ type: CLEAR_SUM_ERROR });
      dispatch({ type: SET_SUM_LOADING });

      const { user } = getState();

      const token = getToken(user);

      const { data } = await unconfiguredMachineStatusAction(year, operatorId, token);

      dispatch({ type: UNCONFIGURED_MACHINE_STATUS, payload: data });
    } catch (error) {
      dispatch({ type: UNCONFIGURED_MACHINE_FAIL, payload: returnError(error) });
    }
  };

export const channelSalesData =
  (year, operatorId) => async (dispatch, getState) => {
    try {
      dispatch({ type: CLEAR_SUM_ERROR });
      dispatch({ type: SET_SUM_LOADING });

      const { user } = getState();
      // console.log('user', user);
      const token = getToken(user);

      const { data } = await channelSalesAction(year, operatorId, token);

      dispatch({ type: CHANNEL_SALES_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: CHANNEL_SALES_FAIL, payload: returnError(error) });
    }
  };

export const machineSalesData =
  (year, operatorId) => async (dispatch, getState) => {
    try {
      dispatch({ type: CLEAR_SUM_ERROR });
      dispatch({ type: SET_SUM_LOADING });

      const { user } = getState();
      // console.log('user', user);
      const token = getToken(user);

      const { data } = await machineSalesAction(year, operatorId, token);

      dispatch({ type: MACHINE_SALES_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: MACHINE_SALES_FAIL, payload: returnError(error) });
    }
  };

export const annualSalesByYear = (reqBody) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_SUM_ERROR });
    dispatch({ type: SET_SUM_LOADING });

    const { user } = getState();
    // console.log('user', user);
    const token = getToken(user);

    const { data } = await annualSalesReportAction(reqBody, token);

    dispatch({ type: ANNUAL_SALES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: ANNUAL_SALES_FAIL, payload: returnError(error) });
  }
};

export const last7DaysSales = () => async (dispatch) => {
  try {
    dispatch({ type: CLEAR_SUM_ERROR });
    dispatch({ type: SET_SUM_LOADING });

    const { data } = await last7DaysSales();

    dispatch({ type: LASTWEEK_SALES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: LASTWEEK_SALES_FAIL, payload: returnError(error) });
  }
};

export const last30DaysSales = (reqBody) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_SUM_ERROR });
    dispatch({ type: SET_SUM_LOADING });

    const { user } = getState();
    const token = getToken(user);

    const { data } = await totalDailySalesBy30daysAction(reqBody, token);

    dispatch({ type: LAST30DAYS_SALES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: LAST30DAYS_SALES_FAIL, payload: returnError(error) });
  }
};

export const weeklySales = (year, operatorId) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_SUM_ERROR });
    dispatch({ type: SET_SUM_LOADING });

    const { user } = getState();
    // console.log('user', user);
    const token = getToken(user);

    const { data } = await weeklySalesAction(year, operatorId, token);

    dispatch({ type: WEEKLY_SALES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: WEEKLY_SALES_FAIL, payload: returnError(error) });
  }
};

export const topSales = (year, operatorId) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_SUM_ERROR });
    dispatch({ type: SET_SUM_LOADING });

    const { user } = getState();
    // console.log('user', user);
    const token = getToken(user);

    const { data } = await totalOutletSalesByYearAction(
      year,
      operatorId,
      token
    );

    dispatch({ type: TOP_SALES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: TOP_SALES_FAIL, payload: returnError(error) });
  }
};

export const todaySales = (operatorId) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_SUM_ERROR });
    dispatch({ type: SET_SUM_LOADING });

    const { user } = getState();
    // console.log('user', user);
    const token = getToken(user);

    const { data } = await todaySalesAction(operatorId, token);

    dispatch({ type: TODAY_SALES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: TODAY_SALES_FAIL, payload: returnError(error) });
  }
};

export const BillAcceptorSalesData = (year, operatorId) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_SUM_ERROR });
    dispatch({ type: SET_SUM_LOADING });

    const { user } = getState();
    const token = getToken(user);

    const { data } = await billAcceptorSalesAction(year, operatorId, token);

    dispatch({ type: BILL_ACCEPTOR_SALES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: BILL_ACCEPTOR_SALES_FAIL, payload: returnError(error) });
  }
};

export const mtdSales = (operatorId) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_SUM_ERROR });
    dispatch({ type: SET_SUM_LOADING });

    const { user } = getState();
    const token = getToken(user);

    const { data } = await mtdSalesAction(operatorId, token);

    dispatch({ type: MTD_SALES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: MTD_SALES_FAIL, payload: returnError(error) });
  }
};

export const todayMachineSales = (outletId) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_SUM_ERROR });
    dispatch({ type: SET_SUM_LOADING });

    const { user } = getState();
    const token = getToken(user);

    const { data } = await todayMachineSalesAction(outletId, token);

    dispatch({ type: TODAY_MACHINE_SALES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: TODAY_MACHINE_SALES_FAIL, payload: returnError(error) });
  }
};

export const mtdMachineSales = (outletId) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_SUM_ERROR });
    dispatch({ type: SET_SUM_LOADING });

    const { user } = getState();
    const token = getToken(user);

    const { data } = await mtdMachineSalesAction(outletId, token);

    dispatch({ type: MTD_MACHINE_SALES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: MTD_MACHINE_SALES_FAIL, payload: returnError(error) });
  }
};

export const monthlyOutletSales = (year, operatorId) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_SUM_ERROR });
    dispatch({ type: SET_SUM_LOADING });

    const { user } = getState();
    const token = getToken(user);

    const { data } = await monthlyOutletSalesAction(year, operatorId, token);
    
    dispatch({ type: MONTHLY_OUTLET_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: MONTHLY_OUTLET_FAILED, payload: returnError(error) });
  }
};

export const dailyOutletSales = (year, month, operatorId) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_SUM_ERROR });
    dispatch({ type: SET_SUM_LOADING });

    const { user } = getState();
    const token = getToken(user);

    const { data } = await dailyOutletSalesAction(year, month, operatorId, token);

    dispatch({ type: DAILY_OUTLET_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: DAILY_OUTLET_FAILED, payload: returnError(error) });
  }
};

export const monthlySingleOutletSales = (year, outletId) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_SUM_ERROR });
    dispatch({ type: SET_SUM_LOADING });

    const { user } = getState();
    const token = getToken(user);

    const { data } = await monthlysingleOutletSalesAction(year, outletId, token);

    dispatch({ type: MONTHLY_SINGLE_OUTLET_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: MONTHLY_SINGLE_OUTLET_FAILED, payload: returnError(error) });
  }
};

export const dailySingleOutletSales = (year, month, outletId) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_SUM_ERROR });
    dispatch({ type: SET_SUM_LOADING });

    const { user } = getState();
    const token = getToken(user);

    const { data } = await dailySingleOutletSalesAction(year, month, outletId, token);

    dispatch({ type: DAILY_SINGLE_OUTLET_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: DAILY_SINGLE_OUTLET_FAILED, payload: returnError(error) });
  }
};

export const billAcceptorTodaySales = (operatorId) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_SUM_ERROR });
    dispatch({ type: SET_SUM_LOADING });

    const { user } = getState();
    const token = getToken(user);

    const { data } = await billAcceptorTodaySalesAction(operatorId, token);

    dispatch({ type: BILL_ACCEPTOR_TODAY_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: BILL_ACCEPTOR_TODAY_FAIL, payload: returnError(error) });
  }
};

export const billAcceptorMTDSales = (operatorId) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_SUM_ERROR });
    dispatch({ type: SET_SUM_LOADING });

    const { user } = getState();
    const token = getToken(user);

    const { data } = await billAcceptorMTDSalesAction(operatorId, token);

    dispatch({ type: BILL_ACCEPTOR_MTD_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: BILL_ACCEPTOR_MTD_FAIL, payload: returnError(error) });
  }
};

export const billAcceptorMonthlyOutletSales = (year, operatorId) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_SUM_ERROR });
    dispatch({ type: SET_SUM_LOADING });

    const { user } = getState();
    const token = getToken(user);

    const { data } = await billAcceptorMonthlyOutletSalesAction(year, operatorId, token);

    dispatch({ type: BILL_ACCEPTOR_MONTHLY_OUTLET_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: BILL_ACCEPTOR_MONTHLY_OUTLET_FAIL, payload: returnError(error) });
  }
};

export const billAcceptorDailyOutletSales = (year, month, operatorId) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_SUM_ERROR });
    dispatch({ type: SET_SUM_LOADING });

    const { user } = getState();
    const token = getToken(user);

    const { data } = await billAcceptorDailyOutletSalesAction(year, month, operatorId, token);

    dispatch({ type: BILL_ACCEPTOR_DAILY_OUTLET_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: BILL_ACCEPTOR_DAILY_OUTLET_FAIL, payload: returnError(error) });
  }
};

export const billAcceptorMonthlySingleSales = (year, outletId) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_SUM_ERROR });
    dispatch({ type: SET_SUM_LOADING });

    const { user } = getState();
    const token = getToken(user);

    const { data } = await billAcceptorMonthlySingleSalesAction(year, outletId, token);

    dispatch({ type: BILL_ACCEPTOR_MONTHLY_SINGLE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: BILL_ACCEPTOR_MONTHLY_SINGLE_FAIL, payload: returnError(error) });
  }
};

export const billAcceptorDailySingleSales = (year, month, outletId) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_SUM_ERROR });
    dispatch({ type: SET_SUM_LOADING });

    const { user } = getState();
    const token = getToken(user);

    const { data } = await billAcceptorDailySingleSalesAction(year, month, outletId, token);

    dispatch({ type: BILL_ACCEPTOR_DAILY_SINGLE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: BILL_ACCEPTOR_DAILY_SINGLE_FAIL, payload: returnError(error) });
  }
};

export const billAcceptorTodaySingleSales = (outletId) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_SUM_ERROR });
    dispatch({ type: SET_SUM_LOADING });

    const { user } = getState();
    const token = getToken(user);

    const { data } = await billAcceptorTodaySingleSalesAction(outletId, token);

    dispatch({ type: BILL_ACCEPTOR_TODAY_SINGLE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: BILL_ACCEPTOR_TODAY_SINGLE_FAIL, payload: returnError(error) });
  }
};

export const billAcceptorMTDSingleSales = (outletId) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_SUM_ERROR });
    dispatch({ type: SET_SUM_LOADING });

    const { user } = getState();
    const token = getToken(user);

    const { data } = await billAcceptorMTDSingleSalesAction(outletId, token);

    dispatch({ type: BILL_ACCEPTOR_MTD_SINGLE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: BILL_ACCEPTOR_MTD_SINGLE_FAIL, payload: returnError(error) });
  }
};

const initialState = {
  error: null,
  loading: false,
  billAcceptorTodaySales: null,
  billAcceptorMTDSales: null,
  billAcceptorMonthlyOutletSales: null,
  billAcceptorDailyOutletSales: null,
  billAcceptorMonthlySingleSales: null,
  billAcceptorDailySingleSales: null,
  billAcceptorTodaySingleSales: null,
  billAcceptorMTDSingleSales: null,
  last30Days: null,
};

export const sumDashReducer = function (state = initialState, action) {
  switch (action.type) {
    // this is for fetching loading time setter
    case SET_SUM_LOADING:
      return {
        ...state,
        loading: true,
      };

    case CLEAR_SUM_ERROR:
      return {
        ...state,
        error: null,
      };

    case MACHINE_STATUS_SUCCESS:
      return {
        ...state,
        status: action.payload.data,
        loading: false,
        error: null,
      };
    
    case MACHINE_BILL_STATUS_SUCCESS:
      return {
        ...state,
        statusBill: action.payload.data,
        loading: false,
        error: null,
      };

    case OUT_OF_SERVICE_MACHINE_STATUS:
      return {
        ...state,
        outOfService: action.payload.data,
        loading: false,
        error: null,
      };
    case CHANNEL_SALES_SUCCESS:
      return {
        ...state,
        channelSales: action.payload.data,
        loading: false,
        error: null,
      };
    case MACHINE_SALES_SUCCESS:
      return {
        ...state,
        machineSales: action.payload.data,
        loading: false,
        error: null,
      };
    case ANNUAL_SALES_SUCCESS:
      return {
        ...state,
        annualSales: action.payload.data,
        loading: false,
        error: null,
      };

    case LASTWEEK_SALES_SUCCESS:
      return {
        ...state,
        last7Days: action.payload.data,
        loading: false,
        error: null,
      };

    case LAST30DAYS_SALES_SUCCESS:
      return {
        ...state,
        last30Days: action.payload.data,
        loading: false,
        error: null,
      };
      
    case LAST30DAYS_SALES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case OUTLET_SALES_SUCCESS:
      return {
        ...state,
        outletSales: action.payload.data,
        loading: false,
        error: null,
      };

    case TODAY_SALES_SUCCESS:
      // console.log('action.payload', action.payload.data);
      return {
        ...state,
        todaySalesData: action.payload.data,
        loading: false,
        error: null,
      };
    case OFFLINE_MACHINE_STATUS:
      return {
        ...state,
        offlineMachines: action.payload.data,
        loading: false,
        error: null,
      };

    case OFFLINE_MACHINE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    
    case UNCONFIGURED_MACHINE_STATUS:
      return {
        ...state,
        unconfiguredMachines: action.payload.data,
        loading: false,
        error: null,
      };
    
    case UNCONFIGURED_MACHINE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case BILL_ACCEPTOR_SALES_SUCCESS:
      return {
        ...state,
        billAcceptorSales: action.payload.data,
        loading: false,
        error: null,
      };
    case OUTLETS_MONTH_SUCCESSV2:
      return {
        ...state,
        outletMonth: action.payload.data,
        loading: false,
        error: null,
      };
    case MTD_SALES_SUCCESS:
      return {
        ...state,
        mtdSalesData: action.payload.data,
        loading: false,
        error: null,
      };

    case MTD_SALES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case TODAY_MACHINE_SALES_SUCCESS:
      return {
        ...state,
        todayMachineSalesData: action.payload,
        loading: false,
        error: null
      };
    case TODAY_MACHINE_SALES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case MTD_MACHINE_SALES_SUCCESS:
      return {
        ...state,
        mtdMachineSalesData: action.payload,
        loading: false,
        error: null
      };
    case MTD_MACHINE_SALES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case TOP_SALES_SUCCESSV2:
      return {
        ...state,
        topSalesDataV2: action.payload.data,
        loading: false,
        error: null,
      };
    case MONTHLY_OUTLET_SUCCESS:
      return {
        ...state,
        monthlyOutletSalesData: action.payload.data,
        loading: false,
        error: null,
      };
    case DAILY_OUTLET_SUCCESS:
      return {
        ...state,
        dailyOutletSalesData: action.payload.data,
        loading: false,
        error: null,
      };
    case MONTHLY_SINGLE_OUTLET_SUCCESS:
      return {
        ...state,
        monthlySingleOutletSalesData: action.payload.data,
        loading: false,
        error: null,
      };
    case DAILY_SINGLE_OUTLET_SUCCESS:
      return {
        ...state,
        dailySingleOutletSalesData: action.payload.data,
        loading: false,
        error: null,
      };
    case BILL_ACCEPTOR_TODAY_SUCCESS:
      return {
        ...state,
        billAcceptorTodaySales: action.payload.data,
        loading: false,
        error: null,
      };

    case BILL_ACCEPTOR_MTD_SUCCESS:
      return {
        ...state,
        billAcceptorMTDSales: action.payload.data,
        loading: false,
        error: null,
      };

    case BILL_ACCEPTOR_MONTHLY_OUTLET_SUCCESS:
      return {
        ...state,
        billAcceptorMonthlyOutletSales: action.payload.data,
        loading: false,
        error: null,
      };

    case BILL_ACCEPTOR_DAILY_OUTLET_SUCCESS:
      return {
        ...state,
        billAcceptorDailyOutletSales: action.payload.data,
        loading: false,
        error: null,
      };

    case BILL_ACCEPTOR_MONTHLY_SINGLE_SUCCESS:
      return {
        ...state,
        billAcceptorMonthlySingleSales: action.payload.data,
        loading: false,
        error: null,
      };

    case BILL_ACCEPTOR_DAILY_SINGLE_SUCCESS:
      return {
        ...state,
        billAcceptorDailySingleSales: action.payload.data,
        loading: false,
        error: null,
      };

    case BILL_ACCEPTOR_TODAY_SINGLE_SUCCESS:
      return {
        ...state,
        billAcceptorTodaySingleSales: action.payload,
        loading: false,
        error: null,
      };

    case BILL_ACCEPTOR_MTD_SINGLE_SUCCESS:
      return {
        ...state,
        billAcceptorMTDSingleSales: action.payload,
        loading: false,
        error: null,
      };
    case MACHINE_STATUS_FAIL:
    case CHANNEL_SALES_FAIL:
    case MACHINE_SALES_FAIL:
    case ANNUAL_SALES_FAIL:
    case OUTLET_SALES_FAIL:
    case LASTWEEK_SALES_FAIL:
    case TODAY_SALES_FAIL:
    case BILL_ACCEPTOR_SALES_FAIL:
    case OUTLETS_MONTH_FAILV2:
    case TOP_SALES_FAILV2:
    case MONTHLY_OUTLET_FAILED:
    case DAILY_OUTLET_FAILED:
    case MONTHLY_SINGLE_OUTLET_FAILED:
    case DAILY_SINGLE_OUTLET_FAILED:
    case BILL_ACCEPTOR_TODAY_FAIL:
    case BILL_ACCEPTOR_MTD_FAIL:
    case BILL_ACCEPTOR_MONTHLY_OUTLET_FAIL:
    case BILL_ACCEPTOR_DAILY_OUTLET_FAIL:
    case BILL_ACCEPTOR_MONTHLY_SINGLE_FAIL:
    case BILL_ACCEPTOR_DAILY_SINGLE_FAIL:
    case BILL_ACCEPTOR_TODAY_SINGLE_FAIL:
    case BILL_ACCEPTOR_MTD_SINGLE_FAIL:
    case MACHINE_BILL_STATUS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case CLEAR_FILTER_SUCCESS:
      return {
        error: null,
        loading: false,
      };

    default:
      return state;
  }
};

const initialState2 = {
  error: null,
  loading: false,
  annualSales: null,
  weeklySalesData: null,
  topSalesData: null,
  topSalesDatav2: null,
};

export const summaryAnnualReducer = function (state = initialState2, action) {
  switch (action.type) {
    // this is for fetching loading time setter
    case SET_SUM_LOADING:
      return {
        ...state,
        loading: true,
      };

    case CLEAR_SUM_ERROR:
      return {
        ...state,
        error: null,
      };

    case ANNUAL_SALES_SUCCESS:
      return {
        ...state,
        annualSales: action.payload.data,
        loading: false,
        error: null,
      };

    case TOP_SALES_SUCCESS:
      return {
        ...state,
        topSalesData: action.payload.data,
        loading: false,
        error: null,
      };
    case WEEKLY_SALES_SUCCESS:
      return {
        ...state,
        weeklySalesData: action.payload.data,
        loading: false,
        error: null,
      };
    case LOGOUT_SUCCESS:
      return initialState;

    case WEEKLY_SALES_FAIL:
    case CHANNEL_SALES_FAIL:
    case TOP_SALES_FAIL:
    case ANNUAL_SALES_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case CLEAR_FILTER_SUCCESS:
      return {
        error: null,
        loading: false,
      };

    default:
      return state;
  }
};
